import type { ChapterSelection } from "./bulk-access";
import type { PublishingRow } from "./queries";

/** A partial page must never silently stand in for a cross-page selection. */
export function loadedSelection(rows: PublishingRow[], total: number, selection: ChapterSelection): PublishingRow[] | null {
    if (selection.mode === "all_matching") {
        if (rows.length !== total) return null;
        const excluded = new Set(selection.excludedChapterIds);
        return rows.filter(row => !excluded.has(row.id));
    }
    const ids = new Set(selection.chapterIds);
    const selected = rows.filter(row => ids.has(row.id));
    return selected.length === ids.size ? selected : null;
}

/** Shared by the authenticated preview action and the already-authorized table. */
export function buildAccessPreview(rows: PublishingRow[]) {
    if (!rows.length) throw new Error("No chapters match this selection anymore");
    const first = rows[0];
    // Free-access dates can elapse while the table stays open.
    const isPaid = first.accessTier === "premium" && (!first.freeAfter || new Date(first.freeAfter).getTime() > Date.now());
    return {
        chapterIds: rows.map(row => row.id), count: rows.length,
        first: first.chapterNumber, last: rows[rows.length - 1].chapterNumber,
        initial: rows.length === 1 ? {
            access: isPaid ? "premium" as const : "free" as const,
            coinPrice: first.coinPrice ?? 1,
            freeAfter: isPaid && first.freeAfter ? new Date(first.freeAfter).toISOString() : null,
        } : null,
    };
}
